export const comments_5618664 = {"data":{"data":[],"links":{}}}